<div class="flex min-w-0 flex-1 w-full flex-col sm:flex-row items-stretch min-h-full">
  <!-- Form side (Left) -->
  <div
    class="w-full px-4 py-8 sm:w-auto sm:rounded-2xl sm:p-12 sm:shadow md:flex md:w-1/2 md:items-center md:justify-end md:rounded-none md:p-16 md:shadow-none bg-background"
  >
    <div class="mx-auto flex w-full max-w-80 flex-col gap-2 sm:mx-0 sm:w-80">
      <!-- Logo & App Name -->
      @if (showLogo()) {
        <ng-content select="[logo]">
          <div class="mb-6 flex items-center">
            <a
              [routerLink]="resolvedLogoLink()"
              class="group flex items-center gap-3 no-underline cursor-pointer select-none"
            >
              <img
                [src]="resolvedLogoUrl()"
                [alt]="resolvedLogoAlt()"
                class="h-10 w-10 shrink-0 transition-transform group-hover:scale-105"
              />
              @if (resolvedAppName()) {
                <span class="font-mono text-5xl font-bold tracking-tight uppercase text-neutral-12">
                  {{ resolvedAppName() }}
                </span>
              }
            </a>
          </div>
        </ng-content>
      }

      <!-- Title & Subtitle Header -->
      @if (title() || subtitle()) {
        <div>
          @if (title()) {
            <div class="leading-tight text-4xl font-extrabold tracking-tight">
              {{ title() }}
            </div>
          }
          @if (subtitle()) {
            <div class="mt-0.5 font-medium text-secondary">
              {{ subtitle() }}
            </div>
          }
        </div>
      }

      <!-- Custom Subtitle Slot (for links, e.g. "Vous n'avez pas de compte ? S'inscrire") -->
      <ng-content select="[subtitle]" />

      <!-- Main Form / Content Projection -->
      <ng-content />

      <!-- Footer Projection -->
      <ng-content select="[footer]" />
    </div>
  </div>

  <!-- Right side Hero / Brand panel -->
  @if (showHero()) {
    <div
      class="bg-neutral-2 border-l border-neutral-3 relative hidden w-1/2 flex-1 items-center justify-center overflow-hidden p-16 md:flex lg:px-28"
    >
      <ng-content select="[hero]">
        <!-- Background Rings -->
        <svg
          class="pointer-events-none absolute inset-0"
          viewBox="0 0 960 540"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMax slice"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g class="text-neutral-6 opacity-30" fill="none" stroke="currentColor" stroke-width="100">
            <circle r="234" cx="196" cy="23"></circle>
            <circle r="234" cx="790" cy="491"></circle>
          </g>
        </svg>

        <!-- Background Dots -->
        <svg
          class="text-neutral-6 opacity-30 absolute -top-16 -right-16"
          viewBox="0 0 220 192"
          width="220"
          height="192"
          fill="none"
        >
          <defs>
            <pattern
              id="auth-split-dots-pattern"
              x="0"
              y="0"
              width="20"
              height="20"
              patternUnits="userSpaceOnUse"
            >
              <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
            </pattern>
          </defs>
          <rect width="220" height="192" fill="url(#auth-split-dots-pattern)"></rect>
        </svg>

        <!-- Hero Content -->
        <div class="relative z-10 w-full max-w-2xl">
          @if (resolvedHeroTitle()) {
            <div class="text-5xl lg:text-6xl text-neutral-12 leading-tight font-bold">
              {{ resolvedHeroTitle() }}
            </div>
          }
          @if (resolvedHeroSubtitle()) {
            <div
              class="text-primary font-semibold text-lg lg:text-xl mt-3 tracking-wide break-words whitespace-normal"
            >
              {{ resolvedHeroSubtitle() }}
            </div>
          }
          @if (resolvedHeroDescription()) {
            <div
              class="text-neutral-11 mt-6 text-lg leading-relaxed tracking-tight break-words whitespace-normal"
            >
              {{ resolvedHeroDescription() }}
            </div>
          }
          @if (resolvedHeroSocialProof()) {
            <div class="mt-8 flex items-center">
              <div class="text-neutral-11 font-medium tracking-tight break-words whitespace-normal">
                {{ resolvedHeroSocialProof() }}
              </div>
            </div>
          }
        </div>
      </ng-content>
    </div>
  }
</div>
